/**
 * The all-regions view (BON-534).
 *
 * Two things and nothing else: the day strip and the roster of regions. No
 * month calendar here — a month grid across every region says nothing useful,
 * and the criteria forbid it at this scope.
 *
 * The roster is a table on wide screens and a stack of cards on a phone. The
 * table does not merely get narrower at 390px: its figures end up off-screen
 * behind a sideways scroll, which defeats the one thing the roster is for.
 */
import { useAllRegionsOverview } from './overview-api';
import { useOverviewViewport } from './overview-viewport';
import { RegionRosterCard } from './RegionRosterCard';
import { RegionRosterStack } from './RegionRosterStack';
import { WorkshopWeekStrip } from './WorkshopWeekStrip';

const NOTE: React.CSSProperties = {
  padding: 14,
  borderRadius: 10,
  background: 'var(--nb-bg)',
  border: '1px dashed var(--nb-border)',
  fontSize: 12.5,
  color: 'var(--nb-subtle)',
};

export function AllRegionsOverview() {
  const { isPhone } = useOverviewViewport();
  const { data, isLoading, isError } = useAllRegionsOverview();

  if (isError) return <p style={NOTE}>Overview could not be loaded. Try again in a moment.</p>;
  if (isLoading || !data) return <p style={NOTE}>Loading…</p>;

  return (
    <>
      <WorkshopWeekStrip strip={data.strip} compact={isPhone} />
      {isPhone ? (
        <RegionRosterStack rows={data.regions} />
      ) : (
        <RegionRosterCard rows={data.regions} weeks={data.window.weeks} />
      )}
    </>
  );
}
